export const colorMapping = {
    'Arts & Culture': '#f792e4',
    'History': '#fbe22b',
    'Life on Land': '#b3ee4c',
    'Oceans & Seas': '#0090fe',
    'Paleontology': '#fc9512',
    'Science': '#1dfdc5',
    'Space': '#a764fd'
};

export const optionsAlbums = [
    { value: 'Arts & Culture', label: 'Arts & Culture' },
    { value: 'History', label: 'History' },
    { value: 'Life on Land', label: 'Life on Land' },
    { value: 'Oceans & Seas', label: 'Oceans & Seas' },
    { value: 'Paleontology', label: 'Paleontology' },
    { value: 'Science', label: 'Science' },
    { value: 'Space', label: 'Space' }
];

export const optionsCollections = [
    { label: "Amazing Astronauts", value: "SAS", album: "Space" },
    { label: "American Folklore", value: "EAF", album: "History" },
    { label: "Amphibians", value: "LAM", album: "Life on Land" },
    { label: "Ancient Creatures", value: "PAN", album: "Paleontology" },
    { label: "Ancient Egypt", value: "EEG", album: "History" },
    { label: "Ancient Greece", value: "EAG", album: "History" },
    { label: "Around the Reef", value: "ORF", album: "Oceans & Seas" },
    { label: "Arthurian Legends", value: "ACAL", album: "Arts & Culture" },
    { label: "Arts & Culture Mythic Cards", value: "ACMY", album: "Arts & Culture" },
    { label: "Arts & Culture Special Fusions", value: "ACFU", album: "Arts & Culture" },
    { label: "Arts & Culture Specials", value: "ACEV", album: "Arts & Culture" },
    { label: "Awesome Aviation", value: "SAA", album: "Science" },
    { label: "Aztec Mythology", value: "ACAZ", album: "Arts & Culture" },
    { label: "Battle!", value: "EBT", album: "History" },
    { label: "Beautiful Butterflies", value: "LBB", album: "Life on Land" },
    { label: "Birds", value: "LBI", album: "Life on Land" },
    { label: "Brilliant Human Body", value: "SBB", album: "Science" },
    { label: "Bugs", value: "LBU", album: "Life on Land" },
    { label: "Carnivores", value: "PCA", album: "Paleontology" },
    { label: "Cephalopods", value: "OCP", album: "Oceans & Seas" },
    { label: "Chinese Folklore", value: "ECF", album: "History" },
    { label: "Climate Change", value: "SCC", album: "Science" },
    { label: "Colors", value: "ACCO", album: "Arts & Culture" },
    { label: "Constellations", value: "SCO", album: "Space" },
    { label: "Cool Cats", value: "LCA", album: "Life on Land" },
    { label: "Crustaceans", value: "OCE", album: "Oceans & Seas" },
    { label: "Curious Cuisine", value: "ACCU", album: "Arts & Culture" },
    { label: "Cute Cats", value: "LCC", album: "Life on Land" },
    { label: "Debunked!", value: "SCD", album: "Science" },
    { label: "Deep Ocean", value: "ODE", album: "Oceans & Seas" },
    { label: "Dizzying Discoveries", value: "SDD", album: "Science" },
    { label: "Documented", value: "EDO", album: "History" },
    { label: "Dogs", value: "LDG", album: "Life on Land" },
    { label: "Donald R. Prothero's Story of Evolution", value: "SPP", album: "Science" },
    { label: "Egyptian Mythology", value: "ACEM", album: "Arts & Culture" },
    { label: "Espionage", value: "EES", album: "History" },
    { label: "Excellent Elements", value: "SEL", album: "Science" },
    { label: "Exciting Exploration", value: "EEE", album: "History" },
    { label: "Exploring the Stars", value: "SST", album: "Space" },
    { label: "Fabulous Fish", value: "OFI", album: "Oceans & Seas" },
    { label: "Fancy Fashions", value: "ACFF", album: "Arts & Culture" },
    { label: "Fears and Phobias", value: "SFP", album: "Science" },
    { label: "Fearsome Flyers", value: "PFF", album: "Paleontology" },
    { label: "Feisty Fish", value: "OFF", album: "Oceans & Seas" },
    { label: "Festive Traditions", value: "ACFE", album: "Arts & Culture" },
    { label: "Feudal Japan", value: "EJP", album: "History" },
    { label: "Fiction and Fantasy", value: "ACFI", album: "Arts & Culture" },
    { label: "Forces of Nature", value: "SFN", album: "Science" },
    { label: "Forces of the Universe", value: "SFO", album: "Space" },
    { label: "Fruit and Veg", value: "LFV", album: "Life on Land" },
    { label: "Funky Fungi", value: "LFF", album: "Life on Land" },
    { label: "Futurology", value: "SFR", album: "Science" },
    { label: "Game Dev!", value: "SGA", album: "Science" },
    { label: "Going Underground", value: "LUN", album: "Life on Land" },
    { label: "Good Sports", value: "ACSP", album: "Arts & Culture" },
    { label: "Gorgeous Graphic Design", value: "ACGD", album: "Arts & Culture" },
    { label: "Grand Designs", value: "SGD", album: "Science" },
    { label: "Greek Mythology", value: "ACGM", album: "Arts & Culture" },
    { label: "Groundbreakers", value: "PGB", album: "Paleontology" },
    { label: "Herbivores", value: "PHE", album: "Paleontology" },
    { label: "Hidden Gems", value: "SGM", album: "Science" },
    { label: "High Voltage!", value: "SEN", album: "Science" },
    { label: "History Mythic Cards", value: "MYHI", album: "History" },
    { label: "History of Heartbreak", value: "EHH", album: "History" },
    { label: "History of the Internet", value: "SHN", album: "Science" },
    { label: "History Special Fusions", value: "FHI", album: "History" },
    { label: "History Specials", value: "HEV", album: "History" },
    { label: "Hoaxes and Cons", value: "EHC", album: "History" },
    { label: "Horrible Halloween", value: "ACHA", album: "Arts & Culture" },
    { label: "Human Evolution", value: "PHU", album: "Paleontology" },
    { label: "Hybrid Animals", value: "LHY", album: "Life on Land" },
    { label: "Ice Age", value: "PIC", album: "Paleontology" },
    { label: "Ingenious Inventions", value: "SNV", album: "Science" },
    { label: "Innovations of War", value: "SIW", album: "Science" },
    { label: "Instrumental", value: "ACIM", album: "Arts & Culture" },
    { label: "Japanese Folklore", value: "EJF", album: "History" },
    { label: "Land Before Time", value: "PLB", album: "Paleontology" },
    { label: "Legends of the Old West", value: "EOW", album: "History" },
    { label: "Life of Land Mythic Cards", value: "MYLO", album: "Life on Land" },
    { label: "Life on Land Special Fusions", value: "FLL", album: "Life on Land" },
    { label: "Life on Land Specials", value: "LEV", album: "Life on Land" },
    { label: "Little Critters", value: "LCR", album: "Life on Land" },
    { label: "Lost Treasures", value: "ELT", album: "History" },
    { label: "Machines of War", value: "SMW", album: "Science" },
    { label: "Majestic Mountains", value: "SMT", album: "Science" },
    { label: "Mammals", value: "LMA", album: "Life on Land" },
    { label: "Marsupials", value: "LAL", album: "Life on Land" },
    { label: "Marvellous Medicine", value: "SME", album: "Science" },
    { label: "Mega Math", value: "SMA", album: "Science" },
    { label: "Molluscs Worms and Water Bugs", value: "OMM", album: "Oceans & Seas" },
    { label: "Money Money Money", value: "ACMO", album: "Arts & Culture" },
    { label: "Monsters of the Deep", value: "PMO", album: "Paleontology" },
    { label: "Moon in Motion", value: "SLP", album: "Space" },
    { label: "Musically Minded", value: "ACMU", album: "Arts & Culture" },
    { label: "Mythical Creatures", value: "LMC", album: "Life on Land" },
    { label: "Natural Monuments", value: "SMO", album: "Science" },
    { label: "Nebulae", value: "SNB", album: "Space" },
    { label: "Norse Mythology", value: "ACNO", album: "Arts & Culture" },
    { label: "Ocean Mammals", value: "OMA", album: "Oceans & Seas" },
    { label: "Ocean Reptiles", value: "ORE", album: "Oceans & Seas" },
    { label: "Oceans & Seas Special Fusions", value: "FSE", album: "Oceans & Seas" },
    { label: "Oceans & Seas Specials", value: "OEV", album: "Oceans & Seas" },
    { label: "Oceans and Seas Mythic Cards", value: "MYSE", album: "Oceans & Seas" },
    { label: "Omnivores", value: "POM", album: "Paleontology" },
    { label: "On Track!", value: "STL", album: "Science" },
    { label: "Once Upon a Time", value: "ACOU", album: "Arts & Culture" },
    { label: "Paleontology Mythic Cards", value: "MYPA", album: "Paleontology" },
    { label: "Paleontology Special Fusions", value: "FPA", album: "Paleontology" },
    { label: "Paleontology Specials", value: "PEV", album: "Paleontology" },
    { label: "Philosophy", value: "ACPH", album: "Arts & Culture" },
    { label: "Pioneers of Science", value: "SPI", album: "Science" },
    { label: "Planetside", value: "SPL", album: "Space" },
    { label: "Plant Life", value: "LPL", album: "Life on Land" },
    { label: "Playtime", value: "ACPY", album: "Arts & Culture" },
    { label: "Plundering Pirates", value: "EPP", album: "History" },
    { label: "Primates", value: "LPR", album: "Life on Land" },
    { label: "Prominent Painters", value: "ACPP", album: "Arts & Culture" },
    { label: "Radical Rockets", value: "SRR", album: "Space" },
    { label: "Raging Rivers", value: "ORR", album: "Oceans & Seas" },
    { label: "Reptiles", value: "LRE", album: "Life on Land" },
    { label: "Riding the Waves", value: "OWA", album: "Oceans & Seas" },
    { label: "Rites and Rituals", value: "ACRR", album: "Arts & Culture" },
    { label: "Science Mythic Cards", value: "MYSC", album: "Science" },
    { label: "Science Special Fusions", value: "FSC", album: "Science" },
    { label: "Science Specials", value: "CEV", album: "Science" },
    { label: "Sea Birds", value: "OBI", album: "Oceans & Seas" },
    { label: "Secret Societies", value: "ESS", album: "History" },
    { label: "Shake Up The System", value: "ESY", album: "History" },
    { label: "Sharks!", value: "OSH", album: "Oceans & Seas" },
    { label: "Signs of the Zodiac", value: "SZO", album: "Space" },
    { label: "Space Mythic Cards", value: "MYSP", album: "Space" },
    { label: "Space Oddities", value: "SOD", album: "Space" },
    { label: "Space Special Fusions", value: "FSP", album: "Space" },
    { label: "Space Specials", value: "SEV", album: "Space" },
    { label: "Space Technology", value: "STE", album: "Space" },
    { label: "Stage and Screen", value: "SSC", album: "Science" },
    { label: "Sue Black's In The Bones", value: "SIB", album: "Science" },
    { label: "Super Structures", value: "STR", album: "Science" },
    { label: "Tarot", value: "ACTA", album: "Arts & Culture" },
    { label: "The American Revolution", value: "EAM", album: "History" },
    { label: "The Four Horsemen", value: "ACFH", album: "Arts & Culture" },
    { label: "The Legend of Robin Hood", value: "ACRH", album: "Arts & Culture" },
    { label: "The Occult", value: "ACTO", album: "Arts & Culture" },
    { label: "The Original Odyssey", value: "ACOO", album: "Arts & Culture" },
    { label: "The Roman Empire", value: "ERO", album: "History" },
    { label: "The Solar System", value: "SSS", album: "Space" },
    { label: "The Write Stuff", value: "ACWS", album: "Arts & Culture" },
    { label: "Tremendous Trees", value: "LTT", album: "Life on Land" },
    { label: "Turbulent Tudors", value: "ETT", album: "History" },
    { label: "Under the Microscope", value: "SUM", album: "Science" },
    { label: "Unruly Rulers", value: "EMM", album: "History" },
    { label: "Venomous Creatures", value: "LVE", album: "Life on Land" },
    { label: "Vicious Vikings", value: "EVV", album: "History" },
    { label: "Volcanoes", value: "SCV", album: "Science" },
    { label: "Walking the World", value: "ACAM", album: "Arts & Culture" },
    { label: "Watching the Skies", value: "SWA", album: "Space" },
    { label: "Weapons of Choice", value: "EWC", album: "History" },
    { label: "Weird World", value: "EWO", album: "History" },
    { label: "West African Folklore", value: "EWA", album: "History" },
    { label: "Wonders of Construction", value: "EWW", album: "History" },
    { label: "World of Words", value: "ACLG", album: "Arts & Culture" }
];

export const optionsTags = [
    {
        "label": "8 Energy",
        "value": "8 Energy",
        "color": "#a764fd"
    },
    {
        "label": "9 Arts and Culture",
        "value": "9 Arts and Culture",
        "color": "#f792e4"
    },
    {
        "label": "9 History",
        "value": "9 History",
        "color": "#fbe22b"
    },
    {
        "label": "9 Life on Land",
        "value": "9 Life on Land",
        "color": "#b3ee4c"
    },
    {
        "label": "9 Oceans & Seas",
        "value": "9 Oceans & Seas",
        "color": "#0090fe"
    },
    {
        "label": "9 Paleontology",
        "value": "9 Paleontology",
        "color": "#fc9512"
    },
    {
        "label": "9 Science",
        "value": "9 Science",
        "color": "#1dfdc5"
    },
    {
        "label": "9 Space",
        "value": "9 Space",
        "color": "#a764fd"
    },
    {
        "label": "Autotune",
        "value": "Autotune",
        "color": "#1dfdc5"
    },
    {
        "label": "Beowulf",
        "value": "Beowulf",
        "color": "#f792e4"
    },
    {
        "label": "Bigshot",
        "value": "Bigshot",
        "color": "#ff5a00"
    },
    {
        "label": "Blitz",
        "value": "Blitz",
        "color": "#f792e4"
    },
    {
        "label": "Blood",
        "value": "Blood",
        "color": "#E50000"
    },
    {
        "label": "Bobbit Worm",
        "value": "Bobbit Worm",
        "color": "#0090fe"
    },
    {
        "label": "Bobblehead",
        "value": "Bobblehead",
        "color": "#f792e4"
    },
    {
        "label": "Boxing",
        "value": "Boxing",
        "color": "#f792e4"
    },
    {
        "label": "Budget",
        "value": "Budget",
        "color": "#b3ee4c"
    },
    {
        "label": "Burn",
        "value": "Burn",
        "color": "#ff5a00"
    },
    {
        "label": "Carl Linnaeus",
        "value": "Carl Linnaeus",
        "color": "#1dfdc5"
    },
    {
        "label": "Chaos",
        "value": "Chaos",
        "color": "#f792e4"
    },
    {
        "label": "Christ of the Abyss",
        "value": "Christ of the Abyss",
        "color": "#fbe22b"
    },
    {
        "label": "Commons",
        "value": "Commons",
        "color": "#B2BEB5"
    },
    {
        "label": "Cow Tipping",
        "value": "Cow Tipping",
        "color": "#fbe22b"
    },
    {
        "label": "Dadaism",
        "value": "Dadaism",
        "color": "#f792e4"
    },
    {
        "label": "Debuff",
        "value": "Debuff",
        "color": "#FFEA00"
    },
    {
        "label": "Delta IV Heavy",
        "value": "Delta IV Heavy",
        "color": "#a764fd"
    },
    {
        "label": "Devil",
        "value": "Devil",
        "color": "#f792e4"
    },
    {
        "label": "Drain",
        "value": "Drain",
        "color": "#0096FF"
    },
    {
        "label": "Egg",
        "value": "Egg",
        "color": "#0090fe"
    },
    {
        "label": "Epics",
        "value": "Epics",
        "color": "#C0C0C0"
    },
    {
        "label": "Eros",
        "value": "Eros",
        "color": "#f792e4"
    },
    {
        "label": "Experimental",
        "value": "Experimental",
        "color": "#1dfdc5"
    },
    {
        "label": "Fairy",
        "value": "Fairy",
        "color": "#b3ee4c"
    },
    {
        "label": "Female",
        "value": "Female",
        "color": "#f792e4"
    },
    {
        "label": "Fun",
        "value": "Fun",
        "color": "#fbe22b"
    },
    {
        "label": "Fusions",
        "value": "Fusions",
        "color": "#f792e4"
    },
    {
        "label": "Goatman",
        "value": "Goatman",
        "color": "#fbe22b"
    },
    {
        "label": "Golden",
        "value": "Golden",
        "color": "#FDDA0D"
    },
    {
        "label": "Golden Lion Tamarin",
        "value": "Golden Lion Tamarin",
        "color": "#b3ee4c"
    },
    {
        "label": "Great Dying",
        "value": "Great Dying",
        "color": "#fc9512"
    },
    {
        "label": "Heimdall",
        "value": "Heimdall",
        "color": "#f792e4"
    },
    {
        "label": "Hell",
        "value": "Hell",
        "color": "#ff5a00"
    },
    {
        "label": "Henrietta Leavitt Swan",
        "value": "Henrietta Leavitt Swan",
        "color": "#a764fd"
    },
    {
        "label": "High Energy",
        "value": "High Energy",
        "color": "#0096FF"
    },
    {
        "label": "Hohenzollern Castle",
        "value": "Hohenzollern Castle",
        "color": "#fbe22b"
    },
    {
        "label": "Inflation",
        "value": "Inflation",
        "color": "#0096FF"
    },
    {
        "label": "James VI & I",
        "value": "James VI & I",
        "color": "#fbe22b"
    },
    {
        "label": "Legendaries",
        "value": "Legendaries",
        "color": "#FDDA0D"
    },
    {
        "label": "Lock",
        "value": "Lock",
        "color": "#899499"
    },
    {
        "label": "Low Energy",
        "value": "Low Energy",
        "color": "#0096FF"
    },
    {
        "label": "Male",
        "value": "Male",
        "color": "#0090fe"
    },
    {
        "label": "Mary Anning",
        "value": "Mary Anning",
        "color": "#fc9512"
    },
    {
        "label": "Medium Energy",
        "value": "Medium Energy",
        "color": "#0096FF"
    },
    {
        "label": "Mono Arts & Culture",
        "value": "Mono Arts & Culture",
        "color": "#f792e4"
    },
    {
        "label": "Mono History",
        "value": "Mono History",
        "color": "#fbe22b"
    },
    {
        "label": "Mono Life on Land",
        "value": "Mono Life on Land",
        "color": "#b3ee4c"
    },
    {
        "label": "Mono Oceans & Seas",
        "value": "Mono Oceans & Seas",
        "color": "#0090fe"
    },
    {
        "label": "Mono Paleontology",
        "value": "Mono Paleontology",
        "color": "#fc9512"
    },
    {
        "label": "Mono Science",
        "value": "Mono Science",
        "color": "#1dfdc5"
    },
    {
        "label": "Mono Space",
        "value": "Mono Space",
        "color": "#a764fd"
    },
    {
        "label": "Moon",
        "value": "Moon",
        "color": "#a764fd"
    },
    {
        "label": "Mythics",
        "value": "Mythics",
        "color": "#FFBF00"
    },
    {
        "label": "New Player Friendly",
        "value": "New Player Friendly",
        "color": "#b3ee4c"
    },
    {
        "label": "Non-Limited",
        "value": "Non-Limited",
        "color": "#DE3163"
    },
    {
        "label": "Overlock",
        "value": "Overlock",
        "color": "#fbe22b"
    },
    {
        "label": "Outdated",
        "value": "Outdated",
        "color": "#808080"
    },
    {
        "label": "Permanent Buffs",
        "value": "Permanent Buffs",
        "color": "#DE3163"
    },
    {
        "label": "Power per Turn",
        "value": "Power per Turn",
        "color": "#DE3163"
    },
    {
        "label": "Rainbow",
        "value": "Rainbow",
        "color": "#DE3163"
    },
    {
        "label": "Rares",
        "value": "Rares",
        "color": "#8B4000"
    },
    {
        "label": "Richard the Lionheart",
        "value": "Richard the Lionheart",
        "color": "#fbe22b"
    },
    {
        "label": "Scorched Earth",
        "value": "Scorched Earth",
        "color": "#FFEA00"
    },
    {
        "label": "Snake",
        "value": "Snake",
        "color": "#b3ee4c"
    },
    {
        "label": "Spider",
        "value": "Spider",
        "color": "#b3ee4c"
    },
    {
        "label": "Statue of Liberty",
        "value": "Statue of Liberty",
        "color": "#1dfdc5"
    },
    {
        "label": "Tennin",
        "value": "Tennin",
        "color": "#fbe22b"
    },
    {
        "label": "The World Turtle",
        "value": "The World Turtle",
        "color": "#b3ee4c"
    },
    {
        "label": "Time Machine",
        "value": "Time Machine",
        "color": "#1dfdc5"
    },
    {
        "label": "Tiny",
        "value": "Tiny",
        "color": "#0096FF"
    },
    {
        "label": "Vitcon",
        "value": "Vitcon",
        "color": "#DE3163"
    }
];

// Custom styles for react-select to apply color mapping
export const customStylesAlbums = {
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? colorMapping[state.data.value] : state.isFocused ? 'var(--color-surface-2)' : 'transparent',
        color: state.isSelected ? 'white' : 'var(--color-text-primary)',
    }),
    control: (provided, state) => ({
        ...provided,
        maxHeight: state.hasValue && state.getValue().length >= 5 ? '110px' : 'auto', // Set the max height for the control
        overflowY: 'scroll', // Make the control scrollable if needed
    }),
    multiValue: (provided, state) => ({
        ...provided,
        backgroundColor: colorMapping[state.data.value],
        color: 'white',
    }),
    multiValueLabel: (provided, state) => ({
        ...provided,
        color: 'white',
    }),
    multiValueRemove: (provided, state) => ({
        ...provided,
        color: 'white',
        ':hover': {
            backgroundColor: 'darken(' + colorMapping[state.data.value] + ', 10%)',
            color: 'white',
        },
    }),
};

export const customStylesCollections = {
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? colorMapping[state.data.album] : state.isFocused ? 'var(--color-surface-2)' : 'transparent',
        color: state.isSelected ? 'white' : 'var(--color-text-primary)',
    }),
    control: (provided, state) => ({
        ...provided,
        maxHeight: state.hasValue && state.getValue().length >= 5 ? '110px' : 'auto', // Set the max height for the control
        overflowY: 'scroll', // Make the control scrollable if needed
    }),
    multiValue: (provided, state) => ({
        ...provided,
        backgroundColor: colorMapping[state.data.album],
        color: 'white',
    }),
    multiValueLabel: (provided, state) => ({
        ...provided,
        color: 'white',
    }),
    multiValueRemove: (provided, state) => ({
        ...provided,
        color: 'white',
        ':hover': {
            backgroundColor: 'darken(' + colorMapping[state.data.album] + ', 10%)',
            color: 'white',
        },
    }),
};

export const customStylesTags = {
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? state.data.color : state.isFocused ? 'var(--color-surface-2)' : 'transparent',
        color: state.isSelected ? 'white' : 'var(--color-text-primary)',
    }),
    control: (provided, state) => ({
        ...provided,
        maxHeight: state.hasValue && state.getValue().length >= 5 ? '110px' : 'auto', // Set the max height for the control
        overflowY: 'scroll', // Make the control scrollable if needed
    }),
    multiValue: (provided, state) => ({
        ...provided,
        backgroundColor: state.data.color,
        color: 'white',
    }),
    multiValueLabel: (provided, state) => ({
        ...provided,
        color: 'white',
    }),
    multiValueRemove: (provided, state) => ({
        ...provided,
        color: 'white',
        ':hover': {
            backgroundColor: 'darken(' + state.data.color + ', 10%)',
            color: 'white',
        },
    }),
};

export const customStylesCards = {
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? colorMapping[optionsCollections.find(collection => collection.value === state.data.value.slice(0, -3)).album] : state.isFocused ? 'var(--color-surface-2)' : 'transparent',
        color: state.isSelected ? 'white' : 'var(--color-text-primary)',
    }),
    multiValue: (provided, state) => ({
        ...provided,
        backgroundColor: colorMapping[optionsCollections.find(collection => collection.value === state.data.value.slice(0, -3)).album],
        color: 'white',
    }),
    multiValueLabel: (provided, state) => ({
        ...provided,
        color: 'white',
    }),
    multiValueRemove: (provided, state) => ({
        ...provided,
        color: 'white',
        ':hover': {
            backgroundColor: 'darken(' + colorMapping[optionsCollections.find(collection => collection.value === state.data.value.slice(0, -3)).album] + ', 10%)',
            color: 'white',
        },
    }),
};